export const hotelGeneralInfoTestIds = {
  hotel_name: 'hotel_general_info_hotel_name',
  hotel_address: 'hotel_general_info_hotel_address',
  hotel_access: 'hotel_general_info_hotel_access',
  hotel_cheapest_price: 'hotel_general_info_hotel_cheapest_price',
  hotel_discounted_price: 'hotel_general_info_hotel_discounted_price',
  reservation_button_desktop: 'hotel_general_info_reservation_button_desktop',
  reservation_button_mobile: 'hotel_general_info_reservation_button_mobile',
  hotel_map: 'hotel_general_info_hotel_map',
  partner_tag: 'hotel_general_info_partner_tag',
};

export const stickyBarTestIds = {
  hotel_name_desktop: 'sticky_bar_hotel_name_desktop',
  hotel_name_mobile: 'sticky_bar_hotel_name_mobile',
  hotel_cheapest_price_desktop: 'sticky_bar_hotel_cheapest_price_desktop',
  hotel_cheapest_price_mobile: 'sticky_bar_hotel_hotel_cheapest_price_mobile',
  hotel_discounted_price_desktop: 'sticky_bar_hotel_discounted_price_desktop',
  hotel_discounted_price_mobile: 'sticky_bar_hotel_discounted_price_mobile',
  reservation_button_desktop: 'sticky_bar_hotel_reservation_button_desktop',
  reservation_button_mobile: 'sticky_bar_hotel_reservation_button_mobile',
};
